import { render, staticRenderFns } from "./PostOrder.vue?vue&type=template&id=fa13edbe&scoped=true&"
import script from "./PostOrder.vue?vue&type=script&lang=js&"
export * from "./PostOrder.vue?vue&type=script&lang=js&"
import style0 from "./PostOrder.vue?vue&type=style&index=0&id=fa13edbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa13edbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib'
import { VCarouselItem } from 'vuetify/lib'
installComponents(component, {VCarousel,VCarouselItem})
